import BaseReducer from "./BaseReducer";

class IntermediaryReducer extends BaseReducer {
  domain = "Intermediary";
  type = "View";

  initialState = {
    open: false,
    alertTime: null,
    capturedImage: null,
    customerId: null,
    estimatedAge: null,
    estimatedGender: null,
    customerName: null,
    customerState: null,
    frsEventReference: null,
    frsEventTypeId: null,
    customerImage: null,
    latestRiskScore: null,
    latestInteractionDate: null,
  };
}

const reducer = new IntermediaryReducer();

export default reducer;